export default "__VITE_ASSET__58c21f35__"